document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('lpm-sticky-bar');
  if (!stickyBar) return;

  const mainForm = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form');
  const mainBuyBtn = document.querySelector('.product-form__submit') || document.querySelector('[name="add"]');
  const variantSelect = document.getElementById('lpm-sticky-variant-select');
  const stickyBtn = document.getElementById('lpm-sticky-add-btn');
  const stickyPrice = document.getElementById('lpm-sticky-price');
  const stickyComparePrice = document.getElementById('lpm-sticky-compare-price');
  const stickyDiscountBadge = document.getElementById('lpm-sticky-discount-badge');

  // Scroll / Intersection observer
  if (mainBuyBtn) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // If main buy button is NOT intersecting (scrolled past), show sticky bar
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(mainBuyBtn);
  } else {
    // Fallback on window scroll
    window.addEventListener('scroll', function () {
      if (window.scrollY > 450) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }, { passive: true });
  }

  // Variant change sync from sticky bar to main form
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const selectedId = this.value;

      if (stickyPrice && selectedOption.dataset.price) {
        stickyPrice.textContent = selectedOption.dataset.price;
      }
      if (stickyComparePrice) {
        if (selectedOption.dataset.comparePrice) {
          stickyComparePrice.textContent = selectedOption.dataset.comparePrice;
          stickyComparePrice.style.display = 'inline';
        } else {
          stickyComparePrice.style.display = 'none';
        }
      }
      if (stickyDiscountBadge) {
        if (selectedOption.dataset.discountPercent) {
          stickyDiscountBadge.textContent = selectedOption.dataset.discountPercent;
          stickyDiscountBadge.style.display = 'inline-block';
        } else {
          stickyDiscountBadge.style.display = 'none';
        }
      }

      // Sync with main hidden input or variant picker
      const mainIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (mainIdInput) {
        mainIdInput.value = selectedId;
        mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Listen to main variant changes to update sticky bar
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (variant) {
      if (variantSelect) {
        variantSelect.value = variant.id;
      }
      if (stickyPrice && variant.price) {
        stickyPrice.textContent = (variant.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
      if (stickyComparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          stickyComparePrice.textContent = (variant.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €';
          stickyComparePrice.style.display = 'inline';
        } else {
          stickyComparePrice.style.display = 'none';
        }
      }
      if (stickyDiscountBadge) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          stickyDiscountBadge.textContent = '-' + pct + '%';
          stickyDiscountBadge.style.display = 'inline-block';
        } else {
          stickyDiscountBadge.style.display = 'none';
        }
      }
    }
  });

  // Sticky button click
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      
      const personalizer = document.querySelector('.zepto-product-personalizer-wrapper') || 
                           document.querySelector('[id*="personalizer"]') ||
                           document.querySelector('.product-form');

      // If personalizer / buy section exists, scroll smoothly to it
      if (personalizer) {
        personalizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (mainBuyBtn && !mainBuyBtn.disabled) {
        mainBuyBtn.click();
      }
    });
  }
});
